const isElement = obj => {
	if (!obj || typeof obj !== 'object') {
		return false
	}

	if (typeof obj.jquery !== 'undefined') {
		obj = obj[0]
	}

	return typeof obj.nodeType !== 'undefined'
}

const getElement = obj => {
	if (isElement(obj)) { // it's a jQuery object or a node element
		return obj.jquery ? obj[0] : obj
	}

	if (typeof obj === 'string' && obj.length > 0) {
		return document.querySelector(obj)
	}

	return null
}

export {
	isElement,
	getElement,
}
